import { render, staticRenderFns } from "./ShortlistDetailsPage.vue?vue&type=template&id=83fa6e56&"
import script from "./ShortlistDetailsPage.vue?vue&type=script&lang=js&"
export * from "./ShortlistDetailsPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports